// Суточная пауза между показами промо-модалок главного меню (приглашения в
// обычный и рейтинговый матч — см. tutorialFinishPromoStorage и
// rankedMatchPromoStorage). Дата последнего закрытия живет в localStorage
// под своим ключом у каждой модалки — как у напоминания о заданиях
// (questsReminderStorage): промо локально для устройства, на другом игрок
// увидит его по своему расписанию

export const DAILY_PROMO_INTERVAL_MS = 24 * 60 * 60 * 1000;

/**
 * Хранилище даты показа для одной модалки.
 *
 * @param {string} storageKey - ключ localStorage с меткой времени закрытия
 * @returns {{checkIfDue: Function, rememberShown: Function, checkIfEverShown: Function}}
 */
export const createDailyPromoStorage = (storageKey) => {
  // null — записи нет либо localStorage недоступен (Safari в приватном
  // режиме): оба случая для показа равнозначны отсутствию записи
  const readStored = () => {
    try {
      return window.localStorage.getItem(storageKey);
    } catch (e) {
      return null;
    }
  };

  /**
   * Пора ли снова показывать: записи нет, она испорчена или ей больше суток.
   * Недоступный localStorage — не повод молчать, показываем как при
   * отсутствии записи
   */
  const checkIfDue = (now = Date.now()) => {
    const stored = readStored();
    if (!stored) return true;

    const shownAt = Number(stored);
    if (!Number.isFinite(shownAt)) return true;
    // Часы устройства могли перевести назад — запись «из будущего» считаем
    // неактуальной, иначе промо замолчало бы до этого будущего момента
    if (shownAt > now) return true;

    return now - shownAt >= DAILY_PROMO_INTERVAL_MS;
  };

  /**
   * Отметить показ. Вызывается ТОЛЬКО когда игрок сам закрыл модалку (любой
   * кнопкой): показ, который он не тронул (перезагрузил страницу, ушел с
   * меню), не считается — иначе ожидание растягивалось бы на каждый заход
   */
  const rememberShown = (now = Date.now()) => {
    try {
      window.localStorage.setItem(storageKey, String(now));
    } catch (e) {
      // Работаем без localStorage: промо просто покажется и в следующий раз
    }
  };

  /**
   * Показывали ли хоть раз на этом устройстве — для уровня события показа
   * (первый показ или напоминание)
   */
  const checkIfEverShown = () => readStored() !== null;

  return {checkIfDue, rememberShown, checkIfEverShown};
};
